import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { Users } from 'lucide-react';

const AssignTeamMembers = ({ caseId, currentTeamMembers, onSuccess }) => {
  const [investigators, setInvestigators] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState(
    currentTeamMembers.map(m => m.id || m._id || m)
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchInvestigators();
  }, []);

  const fetchInvestigators = async () => {
    try {
      const response = await api.get('/users/team-members');
      setInvestigators(response.data.data || []);
    } catch (error) {
      console.error('Error fetching investigators:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.put(`/cases/${caseId}/assign-team`, {
        teamMembers: selectedMembers
      });
      toast.success('Team members assigned successfully');
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to assign team members');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleMember = (memberId) => {
    if (selectedMembers.includes(memberId)) {
      setSelectedMembers(selectedMembers.filter(id => id !== memberId));
    } else {
      setSelectedMembers([...selectedMembers, memberId]);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-4 p-4 bg-gray-50 rounded-lg">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select Team Members
        </label>
        <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-lg p-2">
          {investigators.map((investigator) => (
            <label
              key={investigator.id || investigator._id}
              className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedMembers.includes(investigator.id || investigator._id)}
                onChange={() => handleToggleMember(investigator.id || investigator._id)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="text-sm text-gray-700">
                {investigator.firstName} {investigator.lastName}
              </span>
            </label>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-end space-x-3">
        <button
          type="button"
          onClick={() => onSuccess()}
          className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          <Users className="w-4 h-4" />
          <span>{loading ? 'Assigning...' : 'Assign Team Members'}</span>
        </button>
      </div>
    </form>
  );
};

export default AssignTeamMembers;


